import { apiRequest } from "@/lib/queryClient";
import { Booking } from "@shared/schema";

export interface BookingsResponse {
    success: boolean;
    data: {
        bookings: (Booking & {
            clientName?: string;
            advertiserName?: string;
            cycleName?: string;
            retailerName?: string;
        })[];
        pagination: {
            limit: number;
            offset: number;
            total: number;
            hasMore: boolean;
        };
    };
    message?: string;
}

export interface SingleBookingResponse {
    success: boolean;
    data: {
        booking: Booking & {
            clientName?: string;
            advertiserName?: string;
            cycleName?: string;
            retailerName?: string;
        };
    };
    message?: string;
    warnings?: string[];
}

export interface BookingFilters {
    cycleId?: number;
    clientId?: number;
    advertiserId?: number;
    status?: string;
    search?: string;
    limit?: number;
    offset?: number;
}

export const BookingService = {
    getBookings: async (filters: BookingFilters = {}): Promise<BookingsResponse> => {
        const params = new URLSearchParams();
        if (filters.cycleId) params.append("cycleId", filters.cycleId.toString());
        if (filters.clientId) params.append("clientId", filters.clientId.toString());
        if (filters.advertiserId) params.append("advertiserId", filters.advertiserId.toString());
        if (filters.status) params.append("status", filters.status);
        if (filters.search) params.append("search", filters.search);
        if (filters.limit) params.append("limit", filters.limit.toString());
        if (filters.offset) params.append("offset", filters.offset.toString());

        const res = await apiRequest(`/api/bookings?${params.toString()}`, 'GET');
        return res.json();
    },

    getBooking: async (id: number): Promise<SingleBookingResponse> => {
        const res = await apiRequest(`/api/bookings/${id}`, 'GET');
        return res.json();
    },

    createBooking: async (data: Partial<Booking>): Promise<SingleBookingResponse> => {
        const res = await apiRequest("/api/bookings", "POST", data);
        return res.json();
    },

    updateBooking: async (id: number, data: Partial<Booking>): Promise<SingleBookingResponse> => {
        const res = await apiRequest(`/api/bookings/${id}`, "PUT", data);
        return res.json();
    },

    deleteBooking: async (id: number): Promise<void> => {
        await apiRequest(`/api/bookings/${id}`, "DELETE");
    },

    convertBooking: async (id: number): Promise<{ success: boolean; data: { campaign: any } }> => {
        const res = await apiRequest(`/api/bookings/${id}/convert`, "POST");
        return res.json();
    },
};
